module.exports = __webpack_public_path__ + "static/img/1_7_2.138d4bad.jpg";